<template>
  <el-container class="app-shell">
    <el-aside width="248px" class="app-sidebar">
      <div class="brand-block">
        <div class="brand-mark">YD</div>
        <div>
          <div class="brand-name">亿大智能科技</div>
          <div class="brand-caption">SDK CONTROL CENTER</div>
        </div>
      </div>

      <div class="sidebar-label">工作台</div>
      <el-menu :router="true" :default-active="$route.path" class="app-menu">
        <el-menu-item index="/dashboard">
          <i class="el-icon-data-analysis"></i>
          <span>系统概况</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/users" v-if="canManageUsers">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/products" v-if="userRole === 'admin'">
          <i class="el-icon-box"></i>
          <span>产品管理</span>
        </el-menu-item>
        <el-menu-item index="/dashboard/clients">
          <i class="el-icon-key"></i>
          <span>授权记录</span>
        </el-menu-item>
      </el-menu>

      <div class="sidebar-footer">
        <div class="service-status"><span class="status-dot"></span> 服务运行中</div>
        <div class="service-note">授权数据实时同步</div>
      </div>
    </el-aside>

    <el-container class="app-main">
      <el-header class="app-header">
        <div>
          <div class="eyebrow">AUTHORIZATION SYSTEM</div>
          <div class="page-title">{{ pageTitle }}</div>
        </div>
        <div class="header-actions">
          <div class="identity">
            <span class="avatar">{{ username.slice(0, 1).toUpperCase() }}</span>
            <div>
              <div class="identity-name">{{ username }}</div>
              <div class="identity-role">{{ roleLabel }}</div>
            </div>
          </div>
          <el-dropdown @command="handleCommand">
            <button class="account-trigger" aria-label="账户菜单">
              <i class="el-icon-more"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">账户信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="app-content">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      username: localStorage.getItem('username') || 'Guest',
      userRole: localStorage.getItem('userRole') || ''
    }
  },
  computed: {
    canManageUsers() {
      return this.userRole === 'admin' || this.userRole === 'agent'
    },
    roleLabel() {
      return { admin: '管理员', agent: '经销商', user: '终端用户' }[this.userRole] || '用户'
    },
    pageTitle() {
      const titles = {
        Overview: '系统概况',
        UserManagement: '用户管理',
        ProductManagement: '产品管理',
        ClientManagement: '授权记录'
      }
      return titles[this.$route.name] || '系统概况'
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'profile') {
        this.$message.info(`当前账户：${this.username}`)
        return
      }
      if (command === 'logout') {
        ;['token', 'userRole', 'userId', 'username'].forEach(key => localStorage.removeItem(key))
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.app-shell { min-height: 100vh; background: #f4f7fb; }
.app-sidebar { position: relative; display: flex; flex-direction: column; min-height: 100vh; padding: 28px 16px 20px; background: #0d1b2a; color: #d8e4f1; box-sizing: border-box; }
.brand-block { display: flex; align-items: center; gap: 12px; padding: 0 10px 34px; }
.brand-mark, .avatar { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; border-radius: 10px; font-weight: 700; }
.brand-mark { width: 38px; height: 38px; background: #2f80ed; color: #fff; letter-spacing: 1px; box-shadow: 0 8px 18px rgba(47, 128, 237, .28); }
.brand-name { color: #fff; font-size: 15px; font-weight: 600; }
.brand-caption { margin-top: 4px; color: #7e96ad; font-size: 9px; letter-spacing: 1.2px; }
.sidebar-label { padding: 0 12px 10px; color: #71889e; font-size: 11px; letter-spacing: 1px; }
.app-menu { border-right: 0; background: transparent; }
.app-menu .el-menu-item { height: 48px; line-height: 48px; margin: 4px 0; border-radius: 9px; color: #9bb0c3; transition: background .2s ease, color .2s ease; }
.app-menu .el-menu-item i { margin-right: 10px; color: inherit; font-size: 17px; }
.app-menu .el-menu-item:hover { background: rgba(255, 255, 255, .07); color: #fff; }
.app-menu .el-menu-item.is-active { background: #1c3855; color: #fff; box-shadow: inset 3px 0 #52a7ff; }
.sidebar-footer { margin-top: auto; padding: 15px 12px 0; border-top: 1px solid rgba(255,255,255,.08); }
.service-status { color: #bdd3e5; font-size: 12px; }
.status-dot { display: inline-block; width: 7px; height: 7px; margin-right: 7px; border-radius: 50%; background: #34c759; box-shadow: 0 0 0 4px rgba(52,199,89,.13); }
.service-note { margin-top: 8px; color: #71889e; font-size: 11px; }
.app-main { min-width: 0; }
.app-header { display: flex; align-items: center; justify-content: space-between; height: 86px !important; padding: 0 38px; background: #fff; border-bottom: 1px solid #e7edf4; }
.eyebrow { color: #8a9bad; font-size: 10px; letter-spacing: 1.5px; }
.page-title { margin-top: 5px; color: #16283b; font-size: 22px; font-weight: 700; }
.header-actions { display: flex; align-items: center; gap: 16px; }
.identity { display: flex; align-items: center; gap: 10px; }
.avatar { width: 34px; height: 34px; background: #e9f3ff; color: #2f80ed; font-size: 13px; }
.identity-name { color: #23384e; font-size: 13px; font-weight: 600; }
.identity-role { margin-top: 3px; color: #91a1b1; font-size: 11px; }
.account-trigger { width: 30px; height: 30px; border: 1px solid #e5ebf2; border-radius: 8px; background: #fff; color: #7a8da0; cursor: pointer; }
.account-trigger:hover { border-color: #a9c9ed; color: #2f80ed; }
.app-content { padding: 30px 38px 42px; overflow: auto; }
@media (max-width: 860px) {
  .app-sidebar { width: 72px !important; padding: 22px 10px 16px; }
  .brand-block { justify-content: center; padding: 0 0 28px; }
  .brand-block > div:last-child, .sidebar-label, .app-menu span, .sidebar-footer { display: none; }
  .app-menu .el-menu-item { text-align: center; padding: 0 !important; }
  .app-menu .el-menu-item i { margin-right: 0; }
  .app-header { padding: 0 20px; }
  .app-content { padding: 22px 20px 30px; }
  .identity > div { display: none; }
}
</style>
